import React, { useEffect, useState } from 'react';
import 'lightbox.js-react/dist/index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Select from 'react-select';
import AllStalls from './constant.json';
import Layout from './assets/images/layout.png';
import { SlideshowLightbox } from 'lightbox.js-react';
import { ToastContainer, toast } from 'react-toastify';
import APICall from './Api';
import 'react-toastify/dist/ReactToastify.css';
import Preloader from './common/Loaders/Preloader';
import { useHistory } from 'react-router-dom';
import SweetAlert2 from 'react-sweetalert2';

function Form() {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [openLayout, setOpenLayout] = useState(false);

  const [availableStalls, setAvailableStalls] = useState([]);
  const [stalls, setStalls] = useState([]);
  const [companyName, setCompanyName] = useState('');
  const [contactPersonName, setContactPersonName] = useState('');
  const [contactPersonNumber, setContactPersonNumber] = useState('');

  const [swalProps, setSwalProps] = useState({});

  useEffect(() => {
    fetchStallStatus();
  }, []);

  const fetchStallStatus = () => {
    setLoading(true);
    setAvailableStalls([]);
    APICall.getStallStatus().then((response) => {
      setLoading(false);
      if (response.success) {
        let s = [];
        AllStalls.map((stall) => {
          if (response.data.filter((st) => st.stall === stall.value && st.active).length > 0) {
            s.push(stall);
          }
        });
        setAvailableStalls(s);
      }
    });
  };

  const handleSubmission = () => {
    if (stalls.length === 0) {
      return toast.error('Kindly Select Stall', { hideProgressBar: true });
    }
    if (companyName.trim().length === 0) {
      return toast.error('Kindly Enter Company Name', { hideProgressBar: true });
    }
    if (contactPersonName.trim().length === 0) {
      return toast.error('Kindly Enter Contact Person Name', { hideProgressBar: true });
    }
    if (contactPersonNumber.trim().length === 0) {
      return toast.error('Kindly Enter Contact Number', { hideProgressBar: true });
    }
    if (contactPersonNumber.trim().length !== 10) {
      return toast.error('Kindly Enter Valid Contact Number', { hideProgressBar: true });
    }

    let payload = {
      stalls: stalls,
      company: companyName,
      contact_person: contactPersonName,
      contact_number: contactPersonNumber,
    };

    setLoading(true);

    APICall.createBooking(payload).then((response) => {
      setLoading(false);
      if (response.success) {
        toast.success('Stall Booked Successfully', { hideProgressBar: true });
        fetchStallStatus();
        setCompanyName('');
        setContactPersonName('');
        setContactPersonNumber('');
        setStalls([]);
        sessionStorage.setItem('booking', JSON.stringify(response.data));
        history.push('/thanks');
        return;
      } else {
        setSwalProps({
          show: true,
          title: 'Failed to Book Stall',
          text: response.data,
          icon: 'error',
        });
        setStalls([]);
        fetchStallStatus();
        return;
      }
    });
  };

  return (
    <div className='row'>
      <div className='col-12 col-lg-6'>
        <div className='row'>
          <SlideshowLightbox
            className='container grid grid-cols-3 gap-2 mx-auto'
            open={openLayout}
            onOpen={() => {
              setOpenLayout(true);
            }}
            onClose={() => {
              setOpenLayout(false);
            }}
          >
            <img className='w-full rounded' src={Layout} style={{ width: '100%' }} />
          </SlideshowLightbox>
        </div>
      </div>
      <div className='col-12 col-lg-6'>
        <div className='row'>
          <div className='text-start mb-3'>
            <label className='mb-1 text-muted d-flex justify-content-between align-items-center' style={{ fontSize: '13px' }}>
              <span>Select Stall Number(s)</span>
              <span className='btn btn-link mb-0' style={{ fontSize: '13px', textDecoration: 'none' }} onClick={() => fetchStallStatus()}>
                Get Present Available Stalls
              </span>
            </label>
            <Select
              options={availableStalls}
              isMulti={true}
              isClearable={true}
              value={availableStalls.filter((stall) => stalls.indexOf(stall.value) !== -1)}
              onChange={(e) => {
                setStalls(e.map((s) => s.value));
              }}
            />
          </div>
        </div>
        <div className='row'>
          <div className='text-start mb-3'>
            <label htmlFor='company_name' className='mb-1 text-muted' style={{ fontSize: '13px' }}>
              Company Name
            </label>
            <input
              className='form-control'
              placeholder='Company Name'
              id='company_name'
              value={companyName}
              onChange={(e) => {
                setCompanyName(e.target.value);
              }}
            />
          </div>
        </div>
        <div className='row'>
          <div className='text-start mb-3'>
            <label htmlFor='contact_person_name' className='mb-1 text-muted' style={{ fontSize: '13px' }}>
              Contact Person Name
            </label>
            <input
              className='form-control'
              placeholder='Contact Person Name'
              id='contact_person_name'
              value={contactPersonName}
              onChange={(e) => {
                setContactPersonName(e.target.value);
              }}
            />
          </div>
        </div>
        <div className='row'>
          <div className='text-start mb-3'>
            <label htmlFor='contact_person_number' className='mb-1 text-muted' style={{ fontSize: '13px' }}>
              Contact Person Number
            </label>
            <input
              className='form-control'
              placeholder='Contact Person Number'
              id='contact_person_number'
              value={contactPersonNumber}
              onChange={(e) => {
                let v = e.target.value.replace(/[^0-9]/gi, '');
                if (v.length > 10) {
                  return;
                }
                setContactPersonNumber(v);
              }}
            />
          </div>
        </div>
        <div className='row'>
          <div className='text-start mb-1'>
            <button className='btn btn-primary' onClick={() => handleSubmission()}>
              Book Now
            </button>
          </div>
        </div>
      </div>

      {loading && <Preloader />}

      <SweetAlert2
        {...swalProps}
        didOpen={() => {
          // run when swal is opened...
        }}
        didClose={() => {
          // run when swal is closed...
          setSwalProps({
            show: false,
          });
        }}
        onConfirm={(result) => {
          // run when clieked in confirm and promise is resolved...
        }}
        onError={(error) => {
          // run when promise rejected...
        }}
        onResolve={(result) => {
          // run when promise is resolved...
        }}
      />

      <ToastContainer />
    </div>
  );
}

export default Form;
